import { useTranslation } from 'react-i18next';
import { KpiCard } from '@/shared/components/dashboard/KpiCard';
import { Icons } from '@/shared/components/ui/icons';
import type { WebsiteAnalyticsSummary } from '../types';

interface WebsiteActivityKpisProps {
  summary: WebsiteAnalyticsSummary;
}

export function WebsiteActivityKpis({ summary }: WebsiteActivityKpisProps) {
  const { t } = useTranslation();

  const cards = [
    {
      title: t('websiteActivity.kpi.visitorsToday'),
      value: String(summary.visitorsToday),
      tone: 'cyan' as const,
      icon: <Icons.Eye className="h-5 w-5" />,
    },
    {
      title: t('websiteActivity.kpi.registrationsToday'),
      value: String(summary.registrationsToday),
      tone: 'blue' as const,
      icon: <Icons.Users className="h-5 w-5" />,
    },
    {
      title: t('websiteActivity.kpi.freeTrialsToday'),
      value: String(summary.freeTrialsToday),
      tone: 'green' as const,
      icon: <Icons.Timer className="h-5 w-5" />,
    },
    {
      title: t('websiteActivity.kpi.failedTrialsToday'),
      value: String(summary.failedTrialsToday),
      tone: 'rose' as const,
      icon: <Icons.XCircle className="h-5 w-5" />,
    },
    {
      title: t('websiteActivity.kpi.paymentsStartedToday'),
      value: String(summary.paymentsStartedToday),
      tone: 'amber' as const,
      icon: <Icons.DollarSign className="h-5 w-5" />,
    },
    {
      title: t('websiteActivity.kpi.paymentsSuccessToday'),
      value: String(summary.paymentsSuccessToday),
      tone: 'violet' as const,
      icon: <Icons.CheckCircle className="h-5 w-5" />,
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {cards.map((card) => (
        <KpiCard
          key={card.title}
          title={card.title}
          value={card.value}
          tone={card.tone}
          icon={card.icon}
        />
      ))}
    </div>
  );
}
